import React, {useEffect} from "react";
import {User} from "oidc-client-ts";
import {client, BASE_URL} from "./oidc-settings";

export function Iframe() {
    const noteStyle: React.CSSProperties = {
        fontSize: "0.45em",
        background: "#3a2a00",
        border: "1px solid #665500",
        borderRadius: "8px",
        padding: "10px 14px",
        marginTop: "16px",
        textAlign: "left",
        maxWidth: "70%",
    };

    return (
        <div style={{width: "70%", marginTop: "20px"}}>
            <div style={noteStyle}>
                <b>Known issue:</b> Chrome 142+ / Edge 143+ block this iframe flow on localhost due to{" "}
                <a href="https://developer.chrome.com/blog/local-network-access"
                   target="_blank" rel="noreferrer" style={{color: "#61dafb"}}>
                    Local Network Access (LNA)
                </a>{" "}
                restrictions. The browser prevents the public auth server from redirecting back
                to <code>localhost</code> inside an iframe. This only affects local development
                &mdash; the flow works correctly when deployed to a public domain. To test locally,
                use a tunnel and set the <code>REACT_APP_BASE_URL</code> env var:
                <pre style={{margin: "8px 0 0", fontSize: "0.95em"}}>
{`ngrok http https://localhost:3000
REACT_APP_BASE_URL=https://<id>.ngrok-free.app yarn start`}
                </pre>
            </div>
            <iframe src={`${BASE_URL}/iframeLogin`} allow="local-network-access" style={{width: "100%", height: "100vh"}} />
        </div>
    )
}

// The iframe login flow:
// 1. Iframe loads /iframeLogin which redirects to the auth server
// 2. User authenticates on the auth server
// 3. Auth server redirects back to /iframeCallback inside the iframe
// 4. IframeCallback posts a message to the parent window via postMessage
// 5. Parent window receives the message and loads the user from storage
export function IframeLogin() {
    useEffect(() => {
        client.signinRedirect({redirect_uri: `${BASE_URL}/iframeCallback`}).then((req) => {
            console.log("signinRedirect req", req);
        });
    }, []);

    return (
        <h2>Loading...</h2>
    );
}

export function IframeCallback() {
    useEffect(() => {
        client.signinCallback(location.href).then((user: User | undefined) => {
            console.log("iframeSigninCallback user", user);
            window?.parent.postMessage({type: "oidc.user"}, window.location.origin);
        }).catch(function(err) {
            console.error("failed to process signin response", err);
        });
    }, []);

    return (
        <div>
            <h1>Loading...</h1>
        </div>
    );
}
